export default "__VITE_ASSET__Bxhhw2I4__"